import { render, staticRenderFns } from "./AssetPreventivePlansPanel.vue?vue&type=template&id=3820aad4&scoped=true&"
import script from "./AssetPreventivePlansPanel.vue?vue&type=script&lang=js&"
export * from "./AssetPreventivePlansPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssetPreventivePlansPanel.vue?vue&type=style&index=0&id=3820aad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820aad4",
  null
  
)

export default component.exports